module.exports = __webpack_public_path__ + "img/yxjt_blue.a19d9160.png";